export const config = {

    //local API URL
    // apiUrl: 'http://192.168.1.14/ashtech/api/inquiries',
 
    //live API URL
    apiUrl: 'https://ashtechprojectnoida.com/ashtech/api/inquiries',
}       